import emitAiChatInitiatedEvent from "helpers/emitAiChatInitiatedEvent";
import gtagEventEmitter from "helpers/gtagEventEmitter";

export type SmartQuestionSectionType = "smart_questions" | "faq_smart_search";

interface TrackSmartQuestionChipClickProps {
  section: SmartQuestionSectionType;
  questionKey: string;
  isChatbotOpen?: boolean;
}

interface TrackSmartQuestionSubmittedProps {
  section: SmartQuestionSectionType;
  questionText: string;
  isChatbotOpen?: boolean;
}

/**
 * Fires when a user clicks on a Smart Question chip.
 * Sends the English question key/text (`questionKey`).
 */
export const trackSmartQuestionChipClick = ({
  section,
  questionKey,
  isChatbotOpen = false,
}: TrackSmartQuestionChipClickProps) => {
  if (!isChatbotOpen) {
    emitAiChatInitiatedEvent();
  }
  gtagEventEmitter({
    action: "smart_question_chip_clicked",
    category: "smart_questions",
    section,
    question: questionKey,
  });
};

/**
 * Fires when a user submits a custom question in the Smart Questions input.
 */
export const trackSmartQuestionSubmitted = ({
  section,
  questionText,
  isChatbotOpen = false,
}: TrackSmartQuestionSubmittedProps) => {
  if (!isChatbotOpen) {
    emitAiChatInitiatedEvent();
  }
  gtagEventEmitter({
    action: "smart_question_submitted",
    category: "smart_questions",
    section,
    question: questionText,
    input_type: "custom_input",
  });
};
